export const locales = ['en', 'sv'] as const
export const defaultLocale = 'sv'
export type Locale = (typeof locales)[number]
